<template>
  <div class="pa-10">
    <v-card class="mt-2">
      <v-row class="">
        <v-col cols="12">
          <ProgramsDataTable />
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import ProgramsDataTable from "@/components/Utils/ProgramsDataTable.vue";
export default {
  name: "ProgramsPage",
  components: {
    ProgramsDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {},
};
</script>

<style></style>
